const Config = {
  apiEndpoint: (window.location.href.startsWith("http://localhost:3000/")) ? "http://localhost:3010/" : "https://rolly-api.latentti.io/",
  homepage: (window.location.href.startsWith("http://localhost:3000")) ? "http://localhost:3000" : "https://rolly.latentti.io",
  homefolder: (window.location.href.startsWith("http://localhost:3000")) ? "" : "",
  title: "Rolly"
}

export default Config;
